import { Colors, Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import info from '@/components/info'

const secretRecordFieldNames = [ 'password', 'token', 'apikey' ]

function renderTitleField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.title,
        label: this.getTranslate(`${Services.credentials}.labels.title`),
        dense: true,
        clearable: true,
        required: true,
        details: false,
        autofocus: true,
        mask: /^.{0,255}$/
      },
      on: {
        input: event => {
          this.setTitle(event)
        }
      }
    }
  )
}

function renderInfo(h) {
  if (this.isNew) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${Services.credentials}.hints.info`),
          color: Colors.warning
        }
      }
    )
  }
}

function renderUsernameField(h) {
  return h(
    components['text-field'],
    {
      props: this.getRecordFieldProps('username'),
      on: {
        input: event => {
          this.setRecordValue('username', event)
        }
      }
    }
  )
}
function renderSecretField(h, field) {
  return h(
    components['text-field'],
    {
      props: this.getSecretFieldProps(field),
      on: {
        input: event => {
          this.setRecordValue(field, event)
        }
      }
    }
  )
}
function renderSecretFields(h) {
  return secretRecordFieldNames.map(field => {
    return renderSecretField.call(this, h, field)
  })
}

export default function(h) {
  return h(
    components.form,
    {
      class: {
        [`${Services.credentials}-form`]: true,
        [`${Services.credentials}-form--new`]: this.isNew
      }
    },
    [
      renderTitleField.call(this, h),
      renderInfo.call(this, h),
      renderUsernameField.call(this, h),
      renderSecretFields.call(this, h)
    ].flat()
  )
}
